module.exports = __webpack_public_path__ + "static/media/minus.06c54e8b.svg";